import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavigationBar, Header } from '../shared-components/';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import LoadingBar from 'react-redux-loading-bar';
import * as actions from './redux/actions';
import CategorySelectionModal from './components/CategorySelectionModal';
import ChangePassword from './components/ChangePassword';
import { ToastContainer, toast, Zoom } from 'react-toastify';
import qs from 'qs';
import 'react-toastify/dist/ReactToastify.css';
import ReactGA from 'react-ga';
import { retrieveTopics } from '../topics/redux/retrieveTopics';
import { t } from 'i18next';
import {
  APP_I18N_PREFIX as MY_I18N_PREFIX,
  APP_I18N_KEYS as MY_I18N_KEYS
} from './constants/i18n/Appi18nConstants';
import landingPageRoute from '../landing-page/route';
import { getUserEmailFromLocalStorage } from '../../Firebase/localStorageForUserInfo';
import { apiEndPoints, TOAST_CONTAINER_AUTO_CLOSE_TIME_IN_MILLISECONDS } from '../../common/globalConstants';
import http from '../../common/http';
import { getLoginRedirectUrl } from './sharedFunctions';

class App extends Component {
  static propTypes = {
    children: PropTypes.node,
    location: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  static defaultProps = {
    children: '',
  };

  state = {
    isCategorySelectionModal: false,
    allCategories: [],
    topicDropdown: [],
    allSources: [],
    updateTopicsDropdown: false,
    selectedCategoryId: null,
    isChangePassword: false,
    refreshTopicDropdown: false
  };

  updateSelectedTopic = id => {
    console.log(id)
    const { headerTopicData } = this.props.App;
    const { updateSelectedTopic,  updateTopicDropdownOnAddTopic} = this.props.actions;
    const newTopicDropDown = {
      topicId: id.topicId,
      topicName: id.topicName,
      status: false,
    };
    this.setState({ isLoading: true, selectedCategoryId: id }, () => {
      ReactGA.event(
        {
          category : 'Topic' ,
          action : 'Topic '+id+ ' was selected'
        }
      )
      updateSelectedTopic({
        updatedTopic: this.state.selectedCategoryId,
        prevTopic: headerTopicData,
      });
      //updateTopicDropdownOnAddTopic(newTopicDropDown)
    });
  };

  setActiveTopic = topicStatus => {
    console.log(topicStatus)
    const { updateTopicsDropdown } = this.props.actions;
    const { headerTopicData } = this.props.App;
    if (headerTopicData.topicId != topicStatus.topicId) {
        this.setState({ updateTopicsDropdown: true }, () => {
            updateTopicsDropdown({ updatedTopic: topicStatus, prevTopic: headerTopicData });
        });
    }
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    const {
      updateTopicsdropdownSuccess,
      updateSelectedTopicSuccess,
      updateSelectedTopicFailure,
      allCategories,
      activeTopic,
      retrieveActiveTopicLastSuccessfulTopic
    } = newProps.App;

    if (updateTopicsdropdownSuccess && this.state.updateTopicsDropdown) {
      toast.success('Selected topic has been changed!');
      this.setState({ updateTopicsDropdown: false, refreshTopicDropdown: false }, () => {
        this.props.actions.retrieveActiveTopic();
        this.props.actions.retrieveTopicsDropdown();
        this.props.actions.retrieveActiveTopic();
        this.props.actions.retrieveTopics();
      });
    }
    else if (activeTopic.length > 0 && retrieveActiveTopicLastSuccessfulTopic.length > 0) {
        if (activeTopic[0] !== retrieveActiveTopicLastSuccessfulTopic[0] && !this.state.updateTopicsDropdown && !this.state.refreshTopicDropdown) {
          this.setState({ refreshTopicDropdown: true }, () => {
            this.props.actions.retrieveActiveTopic();
            this.props.actions.retrieveTopicsDropdown();
          });
        }
        else if (activeTopic[0] === retrieveActiveTopicLastSuccessfulTopic[0] && this.state.refreshTopicDropdown) {
          this.setState({ refreshTopicDropdown: false });
        }
    }


    if (updateSelectedTopicSuccess && this.state.selectedCategoryId) {
      const {
        retrieveTopicsDropdown,
        retrieveAllCategories,
        retrieveActiveTopic,
      } = this.props.actions;
      toast.success('Selected topic has been changed!');
      this.setState(
        { selectedCategoryId: null, isCategorySelectionModal: false, isLoading: false },
        () => {
          const parsed = qs.parse(window.location.search,  { ignoreQueryPrefix: true });
          if (parsed.topicId && parsed.topicName) {
            this.props.history.push('/dashboard');
          }
          else {
          retrieveActiveTopic();
          retrieveAllCategories();
          retrieveTopicsDropdown();
          this.props.actions.retrieveTopics();
          }
        },
      );
    }
    if (updateSelectedTopicFailure && this.state.selectedCategoryId) {
      toast.error('Selected topic not has been changed!');
      this.setState({
        selectedCategoryId: null,
        isCategorySelectionModal: false,
        isLoading: false,
      });
    }

    if (JSON.stringify(this.state.allCategories) !== JSON.stringify(allCategories)) {
      this.setState({
        allCategories,
      });
    }
  }

  setActiveTab = tab => {
    this.props.actions.toggleTabs(tab);
  };

  getI18nText(textKey) {
    return t(MY_I18N_PREFIX + "." + textKey);
  }

  componentDidMount() {
    const userEmail = getUserEmailFromLocalStorage();
    if (!userEmail) {
      ReactGA.pageview(getLoginRedirectUrl())
      this.props.history.push(getLoginRedirectUrl());
      return false;
    }

    this.__checkAuthTokenAndRedirectToLoginPageIfCheckFails();

  }

  __checkAuthTokenAndRedirectToLoginPageIfCheckFails() {
    const checkAuthTokenRequest = http.get(apiEndPoints.authentication.CHECK_TOKEN);
    checkAuthTokenRequest.then(
      response => {
        if (this.props.location.pathname === '/') {
          this.props.history.push('/dashboard');
        }
        this.__retrieveInitialData();
      },
      error => {
        this.props.history.push(getLoginRedirectUrl());
        return false;
      },
    );
  }

  __retrieveInitialData() {
    const {
      retrieveActiveTopic,
      retrieveTopicsDropdown,
      retrieveSourcesFilter,
    } = this.props.actions;
    retrieveSourcesFilter();
    retrieveActiveTopic();
    retrieveTopicsDropdown();

    const parsed = qs.parse(window.location.search,  { ignoreQueryPrefix: true });
    if (parsed.topicId && parsed.topicName) {
      let newTopicInfo = {status: false, topicId: parsed.topicId, topicName: parsed.topicName, topicStatus: true};
      this.updateSelectedTopic(newTopicInfo);
    }
  }

  returnIsLandingPage() {
    return (this.props.location.pathname === landingPageRoute.path);
  }
  
  render() {
    const { allCategories, isCategorySelectionModal, isLoading, isChangePassword } = this.state;
    const isLandingPage = this.returnIsLandingPage();
    return (
      <div>
        <div className='banner'>
          <a href="https://www.resonancesocial.com"
             target="_blank" rel="noopener noreferrer"
          >
            <img src="/images/resonance_banner_shortened.png" alt="Resonance Banner" className='banner-logo' />

          </a>
        </div>
      <div className="home-app">
        <LoadingBar
          style={{ backgroundColor: '#2699fb', height: '5px', position: 'fixed', zIndex: '99' }}
        />
        <NavigationBar />
        {!isLandingPage && (<Header
          cookies={this.props.cookies}
          props={this.props}
          setCategorySelectionModalActive={e =>
            this.setState({ isCategorySelectionModal: e }, () => {
              this.props.actions.retrieveAllCategories();
            })
          }
          setActiveTopic={topicId => this.setActiveTopic(topicId)}
          setActiveTab={tab => this.setActiveTab(tab)}
          setIsChangePassword={() => this.setState({ isChangePassword: true })}
        />)}

        <div className="page-container">{this.props.children}</div>
        {isCategorySelectionModal && (
          <CategorySelectionModal
            show={isCategorySelectionModal}
            availableCategories={[...allCategories]}
            isLoading={isLoading}
            setCategorySelectionModalActive={e => this.setState({ isCategorySelectionModal: e })}
            updateSelectedTopic={e => this.updateSelectedTopic(e)}
          />
        )}
        {isChangePassword && (
          <ChangePassword
            cookies = {this.props.cookies}
            show={isChangePassword}
            setIsChangePassword={e => this.setState({ isChangePassword: e })}
          />
        )}
        <ToastContainer
          position="top-center"
          autoClose={TOAST_CONTAINER_AUTO_CLOSE_TIME_IN_MILLISECONDS}
          hideProgressBar
          newestOnTop
          closeOnClick
          transition={Zoom}
          rtl={false}
          pauseOnVisibilityChange
          draggable={false}
          pauseOnHover={false}
        />
        <div className='footer-container'>
          <a href="https://www.a-star.edu.sg/ihpc/ihpc-tech-hub/features/snde/resonance"
              target="_blank" rel="noopener noreferrer"
          >
            <p className='footer-text'>{this.getI18nText(MY_I18N_KEYS.footer)}</p>
          </a>
        </div>
      </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    App: state.home,
    cookies: ownProps.cookies,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, retrieveTopics }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/features/home/App.js